/* eslint-disable import/prefer-default-export */
import {
  Country,
  SampleSize,
  AdNumber,
  Composition,
  ExtraQuestions,
  CompositionNumber,
  CampaignStatements,
  StartDate,
  EndDate,
  CampaignCreatives,
  MediaType,
  DeadLine,
  // CurrentDesign,
  NumberClosedQuestions,
  ExtraOpenQuestions,
  UploadQuestionnaire,
  Reporting,
} from './Components';

export const allTypes = {
  'pre-test-tv': [
    { label: 'sampleSize', Component: SampleSize },
    { label: 'adNumber', Component: AdNumber },
    { label: 'compNumber', Component: CompositionNumber },
    { label: 'composition', Component: Composition },
    { label: 'countries', Component: Country },
    { label: 'extraQuestions', Component: ExtraQuestions },
  ],
  'pre-test-radio': [
    { label: 'sampleSize', Component: SampleSize },
    { label: 'adNumber', Component: AdNumber },
    { label: 'compNumber', Component: CompositionNumber },
    { label: 'composition', Component: Composition },
    { label: 'countries', Component: Country },
    { label: 'extraQuestions', Component: ExtraQuestions },
  ],
  'pre-test-tag-on': [
    { label: 'sampleSize', Component: SampleSize },
    { label: 'adNumber', Component: AdNumber },
    { label: 'mediaType', Component: MediaType },
    { label: 'compNumber', Component: CompositionNumber },
    { label: 'composition', Component: Composition },
    { label: 'countries', Component: Country },
    { label: 'extraQuestions', Component: ExtraQuestions },
  ],
  'pre-test-print': [
    { label: 'sampleSize', Component: SampleSize },
    { label: 'adNumber', Component: AdNumber },
    { label: 'compNumber', Component: CompositionNumber },
    { label: 'composition', Component: Composition },
    { label: 'countries', Component: Country },
    { label: 'extraQuestions', Component: ExtraQuestions },
  ],
  'pre-test-ooh': [
    { label: 'sampleSize', Component: SampleSize },
    { label: 'adNumber', Component: AdNumber },
    { label: 'compNumber', Component: CompositionNumber },
    { label: 'composition', Component: Composition },
    { label: 'countries', Component: Country },
    { label: 'extraQuestions', Component: ExtraQuestions },
  ],
  'pre-test-pos': [
    { label: 'sampleSize', Component: SampleSize },
    { label: 'adNumber', Component: AdNumber },
    { label: 'compNumber', Component: CompositionNumber },
    { label: 'composition', Component: Composition },
    { label: 'countries', Component: Country },
    { label: 'extraQuestions', Component: ExtraQuestions },
  ],
  'pre-test-digital': [
    { label: 'sampleSize', Component: SampleSize },
    { label: 'adNumber', Component: AdNumber },
    { label: 'compNumber', Component: CompositionNumber },
    { label: 'composition', Component: Composition },
    { label: 'countries', Component: Country },
    { label: 'extraQuestions', Component: ExtraQuestions },
  ],
  'animatic-test': [
    { label: 'sampleSize', Component: SampleSize },
    { label: 'adNumber', Component: AdNumber },
    { label: 'compNumber', Component: CompositionNumber },
    { label: 'composition', Component: Composition },
    { label: 'countries', Component: Country },
    { label: 'extraQuestions', Component: ExtraQuestions },
  ],
  'concept-test-product': [
    { label: 'sampleSize', Component: SampleSize },
    { label: 'adNumber', Component: AdNumber },
    { label: 'compNumber', Component: CompositionNumber },
    { label: 'composition', Component: Composition },
    { label: 'countries', Component: Country },
    { label: 'extraQuestions', Component: ExtraQuestions },
  ],
  'packaging-test': [
    { label: 'sampleSize', Component: SampleSize },
    { label: 'adNumber', Component: AdNumber },
    { label: 'compNumber', Component: CompositionNumber },
    { label: 'composition', Component: Composition },
    // { label: 'currentDesign', Component: CurrentDesign },
    { label: 'countries', Component: Country },
    { label: 'extraQuestions', Component: ExtraQuestions },
  ],
  'logo-test': [
    { label: 'sampleSize', Component: SampleSize },
    { label: 'adNumber', Component: AdNumber },
    { label: 'compNumber', Component: CompositionNumber },
    { label: 'composition', Component: Composition },
    // { label: 'currentDesign', Component: CurrentDesign },
    { label: 'countries', Component: Country },
    { label: 'extraQuestions', Component: ExtraQuestions },
  ],
  'claim-test': [
    { label: 'sampleSize', Component: SampleSize },
    { label: 'adNumber', Component: AdNumber },
    { label: 'compNumber', Component: CompositionNumber },
    { label: 'composition', Component: Composition },
    // { label: 'currentDesign', Component: CurrentDesign },
    { label: 'countries', Component: Country },
    { label: 'extraQuestions', Component: ExtraQuestions },
  ],
  'brand-health-check': [
    { label: 'sampleSize', Component: SampleSize },
    { label: 'compNumber', Component: CompositionNumber },
    { label: 'composition', Component: Composition },
    { label: 'countries', Component: Country },
    { label: 'extraQuestions', Component: ExtraQuestions },
  ],
  'campaign-evaluation': [
    { label: 'sampleSize', Component: SampleSize },
    { label: 'compNumber', Component: CompositionNumber },
    { label: 'composition', Component: Composition },
    { label: 'countries', Component: Country },
    { label: 'campaignStatements', Component: CampaignStatements },
    { label: 'extraQuestions', Component: ExtraQuestions },
    { label: 'startDate', Component: StartDate },
    { label: 'endDate', Component: EndDate },
    { label: 'campaignCreatives', Component: CampaignCreatives },
  ],
  'custom-test': [
    { label: 'sampleSize', Component: SampleSize },
    { label: 'compNumber', Component: CompositionNumber },
    { label: 'composition', Component: Composition },
    { label: 'countries', Component: Country },
    { label: 'deadLine', Component: DeadLine },
    { label: 'numberClosedQuestions', Component: NumberClosedQuestions },
    { label: 'extraOpenQuestions', Component: ExtraOpenQuestions },
    { label: 'uploadQuestionnaire', Component: UploadQuestionnaire },
    { label: 'reporting', Component: Reporting },
  ],
  'customer-centricity-scan': [],
  'employee-engagement-scan': [],
};
